/* DAMA measurement extension.
   DamaAnalytics owns Google loading, consent, routing and campaign storage.
   This module sends only consented current-page observations and current clicks.
   It never queues actions from before consent or sends raw contact URLs/phones. */
(function () {
  'use strict';
  if (window.__damaPomiar) return;
  window.__damaPomiar = true;
  var META_ID = '127110164524960';
  var slady = window.__damaSlady = [];
  var api, started = false, metaReady = false, metaConsent = false;
  var gaViewSent = false, metaViewSent = false, checkAvailability = function () {};

  function analyticsAllowed() { try { return api && api.allowed() === true; } catch (_) { return false; } }
  function marketingAllowed() { try { return api && api.marketingAllowed() === true; } catch (_) { return false; } }
  function trace(name, values) {
    if (slady.length >= 100) slady.shift();
    slady.push(name + ' ' + JSON.stringify(values).slice(0, 200));
    if (window.__damaDebug) console.log('[DAMA pomiar]', name, values);
  }
  function sendGA(name, values) {
    if (!name || !analyticsAllowed()) return false;
    try {
      var accepted = api.track(name, values) === true;
      if (accepted) trace(name, values);
      return accepted;
    } catch (_) { return false; }
  }
  function metaCampaign() {
    var values = {}, campaign = api.campaign('marketing') || {};
    if (campaign.dama_campaign) values.campaign = campaign.dama_campaign;
    ['source', 'medium', 'content', 'term', 'id'].forEach(function (key) {
      if (campaign['dama_' + key]) values['campaign_' + key] = campaign['dama_' + key];
    });
    return values;
  }
  function startMeta() {
    if (!marketingAllowed()) return false;
    if (metaReady) {
      if (!metaConsent) window.fbq('consent', 'grant');
      metaConsent = true;
      return true;
    }
    // If another integration owns fbq, reuse its pixel without another init/PageView.
    var existing = typeof window.fbq === 'function';
    if (!existing) {
      var fbq = window.fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('consent', 'grant');
    if (!existing) {
      window.fbq('init', META_ID);
      window.fbq('trackSingle', META_ID, 'PageView', metaCampaign());
    }
    metaReady = true; metaConsent = true;
    return true;
  }
  function sendMeta(name, standard, values) {
    if (!name || !marketingAllowed() || !startMeta()) return false;
    try {
      var mp = metaCampaign();
      if (values.item_name) mp.content_name = values.item_name;
      if (values.item_id) { mp.content_ids = [values.item_id]; mp.content_type = 'product'; }
      if (values.value !== undefined) { mp.value = values.value; mp.currency = values.currency; }
      if (values.salon) mp.salon = values.salon;
      if (values.kraj) mp.kraj = values.kraj;
      if (values.region) mp.region = values.region;
      window.fbq(standard ? 'trackSingle' : 'trackSingleCustom', META_ID, name, mp);
      trace(name, mp);
      return true;
    } catch (_) { return false; }
  }
  function slij(nameGA, values, nameMeta, standard) {
    values = values || {};
    sendGA(nameGA, values);
    sendMeta(nameMeta, standard, values);
  }
  function naKarcie() {
    return (document.body && document.body.dataset.damaPageType === 'product')
        || !!document.querySelector('main.main--product');
  }
  function wFinderze() {
    return !!document.querySelector('.dama-store-finder, [data-finder-list], .stores__menu-item')
        || finderLink(location.href);
  }
  function finderLink(href) {
    try {
      var target = new URL(href, location.href);
      if (target.origin !== location.origin) return false;
      var path = target.pathname.replace(/\/$/, '');
      var configured = document.body && document.body.dataset.damaFinderUrl;
      if (configured) return path === new URL(configured, location.origin).pathname.replace(/\/$/, '');
      return /\/pages\/(salony|store-finder|stores|boutiques|salons|handlersuche)$/i.test(path);
    } catch (_) { return false; }
  }
  function produkt() {
    var m = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || window.meta || {};
    var p = m.product;
    if (!p) return {};
    var v = (p.variants && p.variants[0]) || {};
    return {
      item_id: String(p.id),
      item_name: (v.name || '').split(' - ')[0] || document.title.split('|')[0].trim(),
      item_category: p.type || '',
      value: v.price ? v.price / 100 : undefined,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN'
    };
  }
  function nazwaSalonu(el) {
    var box = el.closest('.lokal__salon, .stores__list-item, .stores__bubble, .product-availability__item, [data-idx], li, article');
    if (!box) return '';
    var mapWindow = el.closest('.gm-style-iw');
    var mapTitle = mapWindow && mapWindow.querySelector('.dama-finder-bubble-title');
    if (mapTitle && (mapTitle.textContent || '').trim()) return mapTitle.textContent.trim().slice(0, 80);
    var h = box.querySelector('strong, .title, h1, h2, h3, h4, h5, h6');
    if (h && (h.textContent || '').trim()) return h.textContent.trim().slice(0, 80);
    var linie = (box.innerText || box.textContent || '')
      .split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
    return linie.length ? linie[0].slice(0, 80) : '';
  }
  /* Miasto salonu z linii adresu z kodem pocztowym: DE/AT/CH/FR „50672 Köln”,
     PL „31-146 Kraków”, CZ „110 00 Praha”, NL „1234 AB Utrecht”. Bez kodu
     (np. adresy brytyjskie) zostaje puste - zdarzenie idzie mimo to. */
  function miastoSalonu(el) {
    var box = el.closest('.lokal__salon, .stores__list-item, .stores__bubble, .product-availability__item');
    if (!box) return '';
    var akapity = box.querySelectorAll('.lokal__adres, p');
    for (var i = 0; i < akapity.length; i++) {
      var kopia = akapity[i].cloneNode(true);
      kopia.querySelectorAll('br').forEach(function (br) { br.replaceWith('\n'); });
      var linie = (kopia.textContent || '').split(/\n|,/);
      for (var j = 0; j < linie.length; j++) {
        var m = /^\s*(?:[A-Z]{1,2}-)?(?:\d{2}-\d{3}|\d{3}\s\d{2}|\d{4,5}(?:\s?[A-Z]{2})?)\s+(\D[^\d]*?)\s*$/.exec(linie[j]);
        if (m) return m[1].slice(0, 60);
      }
    }
    return '';
  }


  function currentPageViews() {
    if (naKarcie()) {
      var p = produkt();
      if (!p.item_id) return;
      if (!gaViewSent) gaViewSent = sendGA('view_item', p);
      if (!metaViewSent) metaViewSent = sendMeta('ViewContent', true, p);
    } else if (wFinderze() && !metaViewSent) {
      metaViewSent = sendMeta('ViewStoreFinder', false, {});
    }
  }
  function observeAvailability() {
    var gaSent = false, metaSent = false, io;
    function visible(el) {
      if (document.hidden) return false;
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      if (!r.height || !h) return false;
      return Math.max(0, Math.min(r.bottom, h) - Math.max(r.top, 0)) / Math.min(r.height, h) >= 0.25;
    }
    checkAvailability = function () {
      var el = document.querySelector('#product-availability');
      if (!el || !visible(el)) return;
      var p = produkt(), values = { item_id: p.item_id, item_name: p.item_name };
      if (!gaSent) gaSent = sendGA('availability_view', values);
      if (!metaSent) metaSent = sendMeta('AvailabilityView', false, values);
      if (gaSent && metaSent) {
        if (io) io.disconnect();
        window.removeEventListener('scroll', checkAvailability);
        document.removeEventListener('visibilitychange', checkAvailability);
      }
    };
    if ('IntersectionObserver' in window) io = new IntersectionObserver(checkAvailability, {threshold: 0.25});
    function attach() {
      var el = document.querySelector('#product-availability');
      if (!el) return false;
      if (io) io.observe(el);
      window.addEventListener('scroll', checkAvailability, {passive: true});
      document.addEventListener('visibilitychange', checkAvailability);
      checkAvailability();
      return true;
    }
    if (!attach()) {
      var mo = new MutationObserver(function () { if (attach()) mo.disconnect(); });
      mo.observe(document.body, {childList: true, subtree: true});
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
  }
  function podepnijKlikniecia() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var karta = naKarcie();
      var p = karta ? produkt() : {};

      /* przycisk "Sprawdz dostepnosc w salonach" */
      if (t.closest('a[data-availability-cta], a.av-ready, a[href="#product-availability"]')) {
        slij('check_boutique_availability', { item_id: p.item_id, item_name: p.item_name },
             'CheckBoutiqueAvailability', false);
        return;
      }

      /* rozwiniecie kraju w sekcji dostepnosci (klik leci przed zmiana stanu) */
      var sum = t.closest('.product-availability__country > summary');
      if (sum) {
        var det = sum.parentElement;
        if (det && !det.open) {
          slij('availability_country_open', {
            kraj: (sum.textContent || '').replace(/\(\d+\)/, '').trim(),
            item_id: p.item_id, item_name: p.item_name
          }, 'AvailabilityCountryOpen', false);
        }
        return;
      }

      /* filtr kraju i regionu w finderze. Kraj bez regionow to <a>, kraj z regionami
         (Niemcy) to <button>, a same regiony to <a data-region>. */
      var flt = t.closest('.stores__menu-item, a[data-region], button[data-region], a[data-all], button[data-all], [data-finder-filter]');
      if (flt && (flt.getAttribute('data-code') || flt.getAttribute('data-region'))) {
        slij('store_finder_filter', {
          kraj: (flt.textContent || '').trim().slice(0, 40),
          kod: flt.getAttribute('data-code') || '',
          region: flt.getAttribute('data-region') || '',
          region_nazwa: flt.getAttribute('data-region-name') || ''
        }, 'StoreFinderFilter', false);
        return;
      }

      var a = t.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var salonLink = !!a.closest('.product-availability__item, #product-availability, [data-finder-list] .stores__list-item, .stores__bubble');
      /* karta salonu na stronie miasta/landu (sections/main-lokal.liquid). Telefon (telMiasta)
         mierzony od 10.10.2026; od tego samego dnia takze mapa i strona www salonu
         (salonMiasta - to samo miejsce, osobna nazwa, zeby galaz telefonu zostala bez zmian).
         Adrian 10.10: klik w www salonu i w mape na stronach miast = dodatkowe konwersje. */
      var telMiasta = !!a.closest('.dama-local .lokal__salon');
      var salonMiasta = telMiasta;
      /* mapa na stronie miasta: obrazek mapy (.lokal__mapa) albo link "Auf Google Maps ansehen".
         Tu lapiemy tez adresy www.google.com/maps/..., ktorych regex karty sukni nie zna
         (karta i finder zostaja przy starym regexie - bez zmian). */
      var mapaMiasta = salonMiasta && href !== '#' && (!!a.closest('.lokal__mapa')
          || /maps\.(google|app\.goo)/i.test(href) || /goo\.gl\/maps/i.test(href)
          || /google\.[a-z.]+\/maps/i.test(href));

      /* telefon salonu - najmocniejszy sygnal, jaki mozemy zlapac.
         10.10.2026: zdarzenie GA4 `salon_phone_click` idzie
         tylko z karty sukni i ze strony miasta (gdzie = karta | miasto).
         W wyszukiwarce GA4 dostaje jak od 16.09 tylko dama_salon_contact_clicked
         z dama-journey.js (bez podwojnego liczenia, uzgodnione z sesja Ads 10.10);
         Meta SalonPhoneClick idzie z wszystkich trzech miejsc jak dotad. */
      if ((salonLink || telMiasta) && /^tel:/i.test(href)) {
        slij(karta || telMiasta ? 'salon_phone_click' : null, {
          salon: nazwaSalonu(a),
          miasto: miastoSalonu(a),
          item_id: p.item_id, item_name: p.item_name,
          gdzie: karta ? 'karta' : (telMiasta ? 'miasto' : 'finder')
        }, 'SalonPhoneClick', false);
        return;
      }

      /* "Zobacz pelna mape" przy salonie w wyszukiwarce salonow (dymek na mapie albo lista).
         Od 21.10.2026 osobne zdarzenie GA4 dama_finder_map_click - Adrian 21.10: osobna
         konwersja dodatkowa, tylko do obserwacji (nie salon_map_click, ktore idzie do Google Ads
         jako konwersja). Lapie tez adresy www.google.com/maps/... (5 salonow w arkuszu).
         Meta dostaje SalonMapClick dokladnie jak dotad (tylko przy starym regexie). */
      if (!karta && !salonMiasta && salonLink && wFinderze() && href !== '#' && (a.classList.contains('dama-finder-map-link')
          || /maps\.(google|app\.goo)/i.test(href) || /goo\.gl\/maps/i.test(href)
          || /google\.[a-z.]+\/maps/i.test(href))) {
        var staryRegexMapy = /maps\.(google|app\.goo)/i.test(href) || /goo\.gl\/maps/i.test(href);
        slij('dama_finder_map_click', {
          salon: nazwaSalonu(a),
          gdzie: 'finder',
          skad: a.closest('.stores__bubble') ? 'dymek' : 'lista'
        }, staryRegexMapy ? 'SalonMapClick' : null, false);
        return;
      }

      /* "Zobacz mape" przy konkretnym salonie (karta sukni, finder, strona miasta) */
      if ((salonLink && (/maps\.(google|app\.goo)/i.test(href) || /goo\.gl\/maps/i.test(href))) || mapaMiasta) {
        slij(karta || salonMiasta ? 'salon_map_click' : null, {
          salon: nazwaSalonu(a), item_id: p.item_id, item_name: p.item_name,
          miasto: salonMiasta ? miastoSalonu(a) : '',
          gdzie: karta ? 'karta' : (salonMiasta ? 'miasto' : 'finder')
        }, 'SalonMapClick', false);
        return;
      }

      /* przejscie z karty do findera */
      if (finderLink(href)) {
        slij('go_to_store_finder', {
          item_id: p.item_id, item_name: p.item_name,
          skad: karta ? 'karta' : 'inne',
          etykieta: (a.textContent || '').trim().slice(0, 40)
        }, 'GoToStoreFinder', false);
        return;
      }

      /* wyjscie na strone salonu (karta sukni, finder, strona miasta) */
      if ((salonLink || salonMiasta) && /^https?:/i.test(href)
          && href.indexOf(location.hostname) === -1
          && !/damacouture\.(pl|de|co\.uk|com|it|fr|es)/i.test(href)
          && !/shopify|facebook\.com|instagram\.com|pinterest|youtube|google\./i.test(href)) {
        slij(karta || salonMiasta ? 'salon_site_click' : null, {
          salon: nazwaSalonu(a),
          miasto: salonMiasta ? miastoSalonu(a) : '',
          item_id: p.item_id, item_name: p.item_name,
          gdzie: karta ? 'karta' : (salonMiasta ? 'miasto' : 'finder')
        }, 'SalonSiteClick', false);
      }
    }, true);
  }


  function sync() {
    api = window.DamaAnalytics;
    if (!api || !window.Shopify || !window.Shopify.customerPrivacy) return false;
    if (!started) {
      started = true;
      podepnijKlikniecia();
      if (naKarcie()) observeAvailability();
    }
    if (metaReady && metaConsent && !marketingAllowed()) {
      window.fbq('consent', 'revoke');
      metaConsent = false;
    }
    if (marketingAllowed()) startMeta();
    currentPageViews();
    checkAvailability();
    return true;
  }
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('dama:analytics-consent', sync);
  document.addEventListener('dama:tracking-ready', sync);
  if (!sync()) {
    var attempts = 0;
    var timer = setInterval(function () { if (sync() || ++attempts >= 40) clearInterval(timer); }, 250);
  }
})();
